import { useEffect, useState } from 'react';
import axios from 'axios';
import { Check, ChevronsUpDown } from 'lucide-react';
import { Button } from '../ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';
import { Command, CommandEmpty, CommandInput, CommandItem, CommandList } from '../ui/command';
import { currencySymbol } from '../../lib/currency';
import { cn } from '../../lib/utils';

let cache = null;
const loadCurrencies = () => {
  if (!cache) {
    cache = axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/currencies`)
      .then((r) => r.data.currencies)
      .catch((e) => { cache = null; throw e; });
  }
  return cache;
};

export const CurrencyPicker = ({ value, onChange }) => {
  const [open, setOpen] = useState(false);
  const [list, setList] = useState([]);
  useEffect(() => { loadCurrencies().then(setList).catch(() => setList([])); }, []);
  const current = list.find((c) => c.code === value);

  return (
    <Popover open={open} onOpenChange={setOpen} modal>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" role="combobox" aria-expanded={open}
          className="w-full justify-between bg-slate-950 border-slate-800 text-white mt-1.5 hover:bg-slate-900 hover:text-white font-normal"
          data-testid="location-currency-select">
          <span className="truncate">{value} · {current ? current.name : currencySymbol(value)}</span>
          <ChevronsUpDown className="w-4 h-4 opacity-50 shrink-0" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[280px] p-0 bg-slate-900 border-slate-800" align="end">
        <Command className="bg-slate-900 text-slate-100"
          filter={(val, search) => (val.toLowerCase().includes(search.toLowerCase()) ? 1 : 0)}>
          <CommandInput placeholder="Search e.g. franc or CAD" data-testid="currency-search-input" />
          <CommandList className="max-h-64">
            <CommandEmpty>No currency found.</CommandEmpty>
            {list.map((c) => (
              <CommandItem key={c.code} value={`${c.code} ${c.name}`}
                onSelect={() => { onChange(c.code); setOpen(false); }}
                data-testid={`currency-option-${c.code}`}>
                <Check className={cn('w-4 h-4 mr-2', value === c.code ? 'opacity-100' : 'opacity-0')} />
                <span className="font-mono text-xs w-10 text-slate-400">{c.code}</span>
                <span className="truncate">{c.name}</span>
                <span className="ml-auto text-xs text-slate-500">{currencySymbol(c.code) !== c.code ? currencySymbol(c.code) : ''}</span>
              </CommandItem>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
